import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { Subject, take, takeUntil } from 'rxjs';
import { UserProfileModel } from 'src/app/admin-panel/models/system-profiles/user-profile.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';
@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public items: MenuItem[];
  public dateOfBirth: string | null;
  public userProfileModel: UserProfileModel;
  public pictureIsWrongFormat: boolean = false;
  public enableEdit: boolean = false;
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  public filePicture: any;
  public pictureFormat: Array<string>;
  public errorModel: { [k: string]: any } = {};
  //#endregion
  //#region Constructor
  constructor(
    private openFile: ElementRef,   
    public administratorService: AdministratorService,    
    private messageService: MessageService
  ) {
    this.items = [{
      label: 'Edit Profile',
      command: () => {
        this.showEdit();
      }
    }];
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    this.userProfileModel = new UserProfileModel();

  }

  ngOnInit(): void {
    this.getuserprofile()
  }
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  //#endregion

  //#region Public Methods

  getuserprofile() {
    this.administratorService.getuserprofile()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.userProfileModel = response;
          const datepipe: DatePipe = new DatePipe('en-US')
          this.userProfileModel.dateOfBirth = new Date((this.userProfileModel.dateOfBirth as string) + "Z")
          this.dateOfBirth = datepipe.transform(this.userProfileModel.dateOfBirth, 'dd/MM/yyyy')
        },
        error: errorResponse => {
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
          }
        }
      });
  }
  showEdit() {

    if (this.enableEdit) {
      this.enableEdit = false;
    } else {
      this.enableEdit = true;
    }

  }
  updateUserProfile(model: UserProfileModel) {
    this.errorModel = {}
    this.administratorService.updateuserprofile(model, this.filePicture)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {        
          this.messageService.add({severity:'success', summary:'User update succesful!',life:1000});        
          this.cancel();
        },
        error: errorResponse => {  
          if (errorResponse.error.errors.FirstName) {
            errorResponse.error.errors.FirstName.forEach((error: string) => {
              this.errorModel['FirstName'] = error;
            });
          }
          if (errorResponse.error.errors.LastName) {
            errorResponse.error.errors.LastName.forEach((error: string) => {
              this.errorModel['LastName'] = error;
            });
          }
          if (errorResponse.error.errors.Phone) {
            errorResponse.error.errors.Phone.forEach((error: string) => {
              this.errorModel['Phone'] = error;
            });
          }
          if (errorResponse.error.errors.DateOfBirth) {
            errorResponse.error.errors.DateOfBirth.forEach((error: string) => {
              this.errorModel['DateOfBirth'] = error;
            });
          }
        }
      });
  }
  cancel() {
    this.errorModel = {}
    this.getuserprofile();
    this.enableEdit = false;
  }

  onFileSelected(event: any) {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      // this.compressImage.compress(image)
      //   .pipe(take(1))
      //   .subscribe(compressedImage => {
      //     this.filePicture = compressedImage;
      //   })
      reader.onload = (item) => { // called once readAsDataURL is completed
        if (item.target?.result) {
          this.userProfileModel.profilePictureUrl = item.target?.result as string
        }
      }
    }
  }
  openAddImage() {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }
  //#endregion
  //#Private Methods
  //#endregion
}
